import React from "react";
import { Props } from "./types";
import styles from "./styles.scss";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@common/skeleton";

function Loader(_: Props) {
  const { t } = useTranslation();
  const days = [
    t("planning.monday"),
    t("planning.tuesday"),
    t("planning.wednesday"),
    t("planning.thursday"),
    t("planning.friday"),
    t("planning.saturday"),
    t("planning.sunday"),
  ];

  return (
    <div className={styles.loader}>
      <div className={styles.caseCalendar}>
        <h2 className={styles.hideElement}>hide</h2>
        <p>{t("taskCreation.allocations.hours")}</p>
      </div>
      {days.map((day) => (
        <div className={styles.caseCalendar}>
          <h2>{day}</h2>
          <Skeleton className={styles.loadingBar} />
        </div>
      ))}
    </div>
  );
}

export { Loader };
